module.exports = __webpack_public_path__ + "static/media/MenuRiceBowlChkn.e2464319.jpg";